<template>
    <div ref="cardRef" :class="['card', (isActive || isMobile) && 'active']">
        <div class="card-header">
            <img class="card-header__img" :src="headerImg" alt="" />
        </div>
        <div class="card-body">
            <div class="card-info">
                <h4 class="card-info__title">
                    {{ priceInfo.title }}<span :style="{ display: isMobile ? 'block' : '' }" v-if="priceInfo.title_tip">{{
                        priceInfo.title_tip }}</span>
                </h4>
                <!-- v-if="priceInfo.kid_type" 去除了课时套餐的title_remark -->
                <h6 class="card-info__sub-title" v-if="priceInfo.kid_type">{{ priceInfo.title_remark }}</h6>
            </div>
            <div class="card-price credit" v-if="activeName === 'credit'">
                <h4 class="card-price-large">{{ priceInfo.price }}</h4>
                <h6 class="card-price-low">
                    {{ priceInfo.describe }}<span class="card-price-low-unit"> / {{ priceInfo.price_unit }}</span>
                </h6>
            </div>
            <div class="card-price vip" v-else>
                <h4 class="card-price-large">
                    {{ priceInfo.price }}<span class="card-price-large-unit"> / {{ priceInfo.price_unit }}</span>
                </h4>
                <h6 class="card-price-low">
                    <div class="card-price-low__remarks">{{ priceInfo.remarks }}</div>
                    <div class="card-price-low__describe" v-if="priceInfo.describe">{{ priceInfo.describe }}</div>
                </h6>
            </div>
            <div class="card-details">
                <el-button type="text" class="card-details-title" @click="handleShowDetail">{{ activeName === 'credit' ?
                    $t('Package details') : $t('PLAN DETAILS') }}<span class="arrow" v-if="isMobile"><i
                            :class="`el-icon-arrow-${showDetail ? 'up' : 'down'}`"></i></span></el-button>
                <el-row :gutter="20" class="card-details-content" v-show="(isMobile && showDetail) || !isMobile">
                    <el-col :span="(isMobile || activeName !== 'credit') ? 24 : 12" class="card-details-content__item" v-for="(item, idx) in detailList"
                        :key="idx">
                        <span class="icon">
                            <i :class="item.icon"></i>
                        </span>
                        <span class="info-text">{{ item.tips }}</span>
                        <el-tooltip class="info-tips" v-if="item.content" effect="light" :content="item.content"
                            :placement="isMobile ? 'bottom' : 'right'">
                            <i class="el-icon-warning-outline warning-icon"></i>
                        </el-tooltip>
                    </el-col>
                </el-row>
            </div>
            <div class="card-line"></div>
            <button class="card-btn" @click="handleClick">
                <span class="card-btn_name">{{ $t("Buy Now") }}</span>
                <span class="icon"><i class="el-icon-right" /></span>
            </button>
        </div>
    </div>
</template>

<script>
import headerImage1 from '@/assets/img/priceCard/head-1.png';
import headerImage2 from '@/assets/img/priceCard/head-2.png';
import headerImage2Zh from '@/assets/img/priceCard/head-2-zh.png';
import vipImage1 from '@/assets/img/priceCard/vip-header-1.png';
import vipImage2 from '@/assets/img/priceCard/vip-header-2.png';
import vipImage3 from '@/assets/img/priceCard/vip-header-3.png';
import vipImage3Zh from '@/assets/img/priceCard/vip-header-3-zh.png';

const headerImageMap = {
    zh_CN: {
        credit: [headerImage1, headerImage2Zh],
        vip: [vipImage1, vipImage2, vipImage3Zh],
    },
    en: {
        credit: [headerImage1, headerImage2],
        vip: [vipImage1, vipImage2, vipImage3],
    }
}

export default {
    props: {
        priceInfo: {
            type: Object,
            default: () => ({}),
        },
        index: {
            type: Number,
            default: 0,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        activeName: {
            type: String,
            default: 'credit',
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showDetail: false,
        };
    },
    computed: {
        headerImg() {
            console.log(this.$i18n.locale, 'this.$i18n.locale')
            const lang = this.$i18n.locale || 'en'
            return headerImageMap[lang][this.activeName][`${this.index}`];
        },
        detailList() {
            const list = [];
            if (this.activeName === 'credit') {
              const afterTipMap = {
                    tip1: this.getListObj(this.$t('Top Certified U.S. Teachers')),
                    tip2: this.getListObj(this.$t('100%-Live-Classes')),
                    tip3: this.getListObj(this.$t('Take classes in any subjects')),
                    tip4: this.getListObj(this.$t('Customized Schedule')),
                };
                Object.keys(this.priceInfo).forEach((key) => {
                    if (key.startsWith('tip')) {
                        if(key=='tip4'&&!this.priceInfo[key]){

                        }
                        else{
                          // 这里去除tip2和tip3
                          if(key != 'tip2' && key != 'tip3'){
                            list.push(this.getListObj(this.priceInfo[key], key));
                          }
                        }

                        if (!this.isMobile) {
                          list.push(afterTipMap[key]);
                        }
                    }
                });
                // if (this.index === 1) {
                //     list.push(this.getListObj(this.$t('Credits never expire')));
                // }
                if (this.isMobile) {
                  list.push(...[afterTipMap['tip1'], afterTipMap['tip2'], afterTipMap['tip3'], afterTipMap['tip4']]);
                }
            } else {
                list.push(...(this.priceInfo.plan_details || []).map(this.getListObj));
            }
            return list;
        },
        getStyle() {
            return (index) => {
                if (this.activeName === 'credit' && !this.isMobile) {
                    return {
                        width: '48%',
                        marginLeft: index % 2 === 1 ? '15px' : '',
                    };
                } else {
                    return {};
                }
            };
        },
    },
    methods: {
        handleClick() {
            console.log('handleClick');
            this.$emit('btnClick');
        },
        handleShowDetail() {
            console.log('showDetail');
            this.showDetail = !this.showDetail;
        },
        getListObj(tips, key) {
            const iconClass = ['el-icon-star-on icon-yellow bolder', 'el-icon-check icon-green bolder'];
            const contentStringList = [this.$t('Refundable portion, Transaction fee will be charged for refund'), this.$t('Non-Refundable portion')];
            let content = '';
            if ('tip1' === key) {
                content = contentStringList[0];
            }
            if ('tip2' === key) {
                content = contentStringList[1];
            }
            if (this.index === 1) {
                if (key === 'tip3') {
                    content = contentStringList[1];
                }
            }
            // if (key === 'tip4' && !tips) {
            //     tips = this.$t('Credits never expire');
            // }
            return {
                icon: key && key === 'tip2' && this.index === 1 ? iconClass[0] : iconClass[1],
                content,
                tips,
            };
        },
    },
};
</script>

<style lang="less">
.el-tooltip__popper {
    border: 1px solid rgba(230, 230, 230, 0.25) !important;
    box-shadow: 0px 0px 15px 5px rgba(200, 200, 200, 0.2) !important;
    max-width: 280px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;

    &.is-light .popper__arrow {
        border: 1px solid rgba(230, 230, 230, 1) !important;
        box-shadow: 0px 0px 15px 5px rgba(200, 200, 200, 0.2) !important;
        background-color: #fff;
    }
}
</style>

<style lang="less" scoped>
.card {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #dbdbdb;
    display: flex;
    flex-direction: column;
    font-family: 'Inter';
    font-style: normal;
    overflow-x: hidden;
    // height: 100%;

    h4,
    h6,
    ul,
    li {
        margin: 0;
        padding: 0;
    }

    ul {
        list-style: none;
    }

    &.active {
        box-shadow: 0px 25px 50px -12px rgba(16, 24, 40, 0.25);

        .card-btn {
            background: #4b4efc;
            color: #f5f5ff;
            transition: background 0.25s ease-in-out;
        }

        transform: scale(1.02);
        transition: all 0.25s ease-in-out;
    }

    // &:hover {
    //     box-shadow: 0px 25px 50px -12px rgba(16, 24, 40, 0.25);
    //     .card-btn {
    //         background: #4b4efc;
    //         color: #f5f5ff;
    //     }
    // }

    &-header {
        width: 100%;

        &__img {
            width: 100%;
        }
    }

    &-body {
        margin-top: 30px;
        padding: 0 28px;

        .card-info {
            &__title {
                font-weight: 700;
                font-size: 24px;
                line-height: 24px;
                font-family: 'Inter';
                font-style: normal;

                span {
                    font-size: 16px;
                }
            }

            &__sub-title {
                margin-top: 12px;
                font-weight: 500;
                font-size: 16px;
                height: 20px;
                line-height: 20px;
                color: #6b7280;
                font-family: 'Inter';
                font-style: normal;
            }
        }

        .card-price {
            color: #111827;
            margin-top: 32px;

            &-large {
                font-weight: 700;
                font-size: 40px;
                letter-spacing: -0.02em;
                font-family: 'Inter';
                font-style: normal;

                &-unit {
                    font-weight: 500;
                    font-size: 14px;
                    color: #9ca3af;
                    font-family: 'Inter';
                    font-style: normal;
                }
            }

            &-low {
                font-weight: 600;
                font-size: 20px;
                height: 34px;
                font-family: 'Inter';
                font-style: normal;

                &__remarks {
                font-family: 'Inter';
                font-style: normal;
                }

                &__describe {
                    font-family: 'Inter';
                font-style: normal;
                }

                &-unit {
                    font-weight: 500;
                    font-size: 14px;
                    color: #9ca3af;
                    font-family: 'Inter';
                    font-style: normal;
                }
            }
        }

        .vip {
            .card-price-low {
                display: flex;
                font-family: 'Inter';
                font-style: normal;
                align-items: flex-start;

                &__describe {
                    font-family: 'Inter';
                    font-style: normal;
                    color: #15803d;
                    font-weight: 500;
                    font-size: 12px;
                    height: 20px;
                    line-height: 20px;
                    padding: 3px 10px;
                    background: #f0fdf4;
                    border-radius: 24px;
                    margin-left: 10px;
                }
            }
        }

        .card-details {
            margin-top: 20px;
            font-family: 'Inter';
            font-style: normal;

            &-title {
                font-weight: 700;
                font-size: 14px;
                color: #000000;
                margin-bottom: 5px;
                font-family: 'Inter';
                font-style: normal;
                text-transform: uppercase;

                /deep/ span {
                    font-family: 'Inter' !important;
                    font-style: normal;
                }

                .arrow {
                    color: #333;
                    margin-left: 5px;
                }
            }

            &-content {
                display: flex;
                flex-wrap: wrap;
                flex-grow: 1;
                font-family: 'Inter';
                font-style: normal;

                &__item {
                    margin-bottom: 16px;
                    display: flex;
                    font-family: 'Inter';
                    font-style: normal;

                    .icon {
                        font-size: 16px;

                        &-green {
                            color: #22c55e;
                        }

                        &-yellow {
                            color: #faa923;
                        }

                        .bolder {
                            font-weight: 700;
                        }
                    }

                    .info-text {
                        margin: 0 5px 0 10px;
                        color: #111827;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 20px;
                        font-family: 'Inter';
                        font-style: normal;
                        // text-align: justify;
                        // flex-shrink: 1;
                        max-width: 81%;
                    }

                    /deep/.el-tooltip__popper {
                        border: none;
                    }

                    .warning-icon {
                        font-size: 20px;
                        color: #787878;
                    }

                    // &:nth-child(even) {
                    //     margin-left: 30px;
                    // }
                }
            }
        }

        .card-line {
            width: 100%;
            height: 1px;
            background: #e5e7eb;
            margin: 0 0 20px 0;
        }

        .card-btn {
            align-self: center;
            margin-bottom: 60px;
            width: 100%;
            height: 48px;
            background: #f5f5ff;
            border-radius: 34px;
            border: none;
            font-weight: 500;
            font-size: 18px;
            cursor: pointer;
            color: #4b4efc;
            font-family: 'Inter';
            font-style: normal;

            &_name {
                font-family: 'Inter';
                font-style: normal;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/PriceCard.vue